import type { DeliveryItem } from '~/models/PlannedDelivery/DeliveryItem'
import { ArrayService } from './serviceLive'
import { query } from 'firebase/firestore'

export class DeliveryItemService extends ArrayService<DeliveryItem> {
  private _collection

  constructor() {
    super('PlannedDeliveries', { collectionGroupName: 'DeliveryItems' })
    const { collection } = useFirebase()
    this._collection = collection
  }

  public listenForDeliveryItemsByDeliveryIds(deliveryIds: string[]): void {
    const listenQueries = deliveryIds.map((deliveryId) => {
      return query(
        this._collection(`PlannedDeliveries/${deliveryId}/DeliveryItems`),
      )
    })

    this.listenGroup(listenQueries)
  }
}
